export default __webpack_public_path__ + "static/media/bg-dark-large.93b071b6.png";